import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '13px',
    height: '20px',
  },
}

const CursorIconActive = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 13 21"
  >
    <svg fill="none">
      <path
        d="M2.28489 0.847656C1.54593 6.86591 0.714966 13.1509 0.0664062 18.3956C1.53018 17.5961 2.98859 16.7869 4.44873 15.9809C4.88557 17.6169 5.32239 19.253 5.75924 20.889C6.94197 20.571 8.19174 20.2349 9.21526 19.9597C8.77912 18.3262 8.34297 16.6928 7.90682 15.0593C9.57569 15.0342 11.2446 15.0107 12.9134 14.9825C9.23619 10.0897 5.45154 5.05314 2.28489 0.847656Z"
        fill="white"
      />
      <path
        d="M6.1131 20.2761L4.93181 15.8519L4.76686 15.2341L4.20709 15.5431C3.84997 15.7403 3.49315 15.9375 3.13646 16.1347C2.31859 16.5867 1.50142 17.0384 0.683052 17.4877C0.949359 15.354 1.2429 13.0602 1.54553 10.6955C1.9042 7.89283 2.27562 4.9905 2.62957 2.13681C5.39525 5.81108 8.56602 10.0301 11.6981 14.1977L11.9243 14.4987C11.0311 14.5129 10.1378 14.5261 9.24418 14.5394C8.79598 14.546 8.34769 14.5526 7.89928 14.5594L7.2584 14.5691L7.42375 15.1883L8.60343 19.6064L6.1131 20.2761Z"
        stroke="black"
        strokeOpacity="0.5"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(CursorIconActive)
